import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
  },
  tableWrapper: {
    paddingBlock: 12,
  },
  editIcon: {
    border: `1px solid #11823b`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#11823b",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  deleteIcon: {
    border: `1px solid #ff2020db`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ff2020db",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  historyIcon:{
    border: `1px solid #f140a9`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#000000",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  actiontypo:{
    padding: 2,
    color:"#fff",
    "&.MuiTypography-subtitle2":{
      fontSize: 14,
    },
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    rowGap: 8,
    "& .MuiTypography-root": {
      fontWeight: 500,
    },
    "& .MuiButton-root": {
      color: "gray",
      textTransform: "capitalize",
      border: "1px solid #c5baba",
      "&:hover": {
        border: "1px solid #848181",
        backgroundColor: "#fff",
      },
    },
  },
  dataGridTable: {
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 400,
      textTransform: "uppercase",
      fontSize: 12,
    },
    "& .MuiDataGrid-iconSeparator ": {
      color : "#000 !important",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 8,
      },
    },
  },
  lightText: {
    "& .MuiTypography-root": {
      color: "rgba(0, 0, 0, 0.7)",
    },
  },
  linkText: {
    "& .MuiTypography-root": {
      color: "#0f5fff",
      cursor: "pointer",
    },
  },
  spacing: {
    paddingBlockStart: 4,
  },
  iconsWrapper: {
    display: "flex",
    gap: 8,
  },
  deleteIcon: {
    border: `1px solid #ff2020db`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 5,
    padding: 2,
    alignItems: "center",
    background: "#ff2020db",
    "& .MuiSvgIcon-root": {
      color: "#ffffff",
      cursor: "pointer",
      fontSize: 20,
    },
  },
  addBtn: {
    display: "flex",
    justifyContent: "flex-start",
    padding: "10px 20px",
  },
}));


export default useStyles;
